export default __webpack_public_path__ + "static/media/Hyundai-3d-model-with-accessories.562bf431.png";